<style lang="scss" scoped>
@import '$vars';
.offices {
  background: #f1f1f1;
  border: 1px solid #e1e1e1;
  padding: 10px;
}
.payment {
  ul {
    display: flex;
    justify-content: flex-start;
    li {
      padding: 0 1em 0 0;
      >div {
        input {
          width: 100px
        }
      }
    }
  }
}
.offices {
  font-size: 0.8em;
  margin-top: 1em;
  h3 {
    font-size: 1.5em;
  }
}
.menu .menu-item > a {
  white-space: nowrap;
}
.agenda {
  >ul {
    display: flex;
    flex-direction: row;
    margin: 2em -5px;
    >li {
      width: 100%;
      margin: 0 5px;
      min-height: 60px;
      >label {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 60px;
        outline: 1px solid #a1a1a1;
        background: #f1f1f1;
        transition: all 200ms;
        color: inherit;
        &.selected {
          background: $color-blue;
          color: white
        };
      }
      input {
        display: none;
      }
      small {
        font-size: 0.6em
      }
      .btn {
        margin-top: 10px !important
      }
    }
  }

  .periods {
    >main {
      background: #f1f1f1;
      padding: 10px;
    }
    fieldset {
      margin: 0 1%;
      text-align: left;
      label {
        height: 20px;
      }
      select {
        background: transparent !important;
      }
    }
    .btn {
      margin: auto;
      font-weight: normal;
      color: white;
      background: $color-blue;
      font-size: 10px;
      border-radius: 1.4em;
      padding-left: 2.4em;
      padding-right: 2.4em;
      height: 2.8em;
      letter-spacing: 0
    }
    select {
      font-style: italic
    }
    .chip {
      align-items: flex-start;
      background: #f1f1f1;
      background: $color-green;
      background: #27F0C5;
      color: $color-blue;
      color: #ffffff;
      display: flex;
      flex-direction: row;
      flex-grow: 0;
      font-size: 0.7rem !important;
      font-style: normal;
      font-weight: 600;
      justify-content: flex-end;
      margin-top: 15px;
      max-width: 120px;
      padding: 5px;
      white-space: nowrap;
      width: 90px;

      div {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        margin-right: 5px;

        span:first-of-type {
          margin-bottom: 5px;
        }
      }

      strong {
        margin-top: -2px;
      }
    }
  }
}
label>strong {
  font-weight: bold;
}
.weekday {
  font-size: 1em !important
}
.tooltip {
  &::after {
    background: #FDF9C8;
    color: #4a4a4a;
    border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16);
    padding: 0.8rem 1rem;
    margin-bottom: 0.5rem;
  }
  &:focus,
  &:hover {
    &::after {
      opacity: 1;
      transform: translate(-10%, -$unit-1);
    }
  }
  .v-icon {
    display: inline-block;
    float: none;
    margin-left: 7px;
    height: 15px;
    width: 15px;
  }
}

.btn-adicionar-consultorio {
  display: flex;
  align-items: center;
  flex-direction: row;

  i {
    margin-top: 1px;
    margin-right: 5px;
  }
}

.timepicker {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 0.8rem;

  .form-select {
    font-size: 0.8rem;
    max-width: 60px;
    padding-right: 10px;
  }
}

.chip-wrapper {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>
<style lang="scss">
@import '$vars';

.doctorOffices {
  box-sizing: border-box;
  @screen mobile {
    .dropdown, .dropdown a {
      @apply block;
    }
    >div {
      @apply my-2 mx-auto flex-wrap;
      .btn {
        @apply mx-auto;
      }
    }
  }
}

.available-days {
  box-sizing: border-box;
  margin: 0 auto 1rem auto;
  width: 100%;

  &__header {
    background-image: $color-gradient;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 1rem 1.7rem;
  }

  &__title {
    color: #ffffff;
    display: block;
    font-family: $font1;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    width: 85%;
  }

  &__body {
    background: #F8F9FA;
    padding: 1rem;

    .transparent {
      select {
        background-color: transparent !important;
      }
    }

    .agenda {
      margin-top: 1rem;

      ul {
        margin-top: 0.5rem;
      }
    }
  }
}
.officeEnd{
  display: flex;
  align-items: center;
}
.payment.hide {
  display: none;
}
</style>

<template>
  <main v-if="loaded" ref="doctorOffices" class="doctorOffices minhaconta__body">
    <div v-if="!selectedOffice && !fn_IS_MOBILE()">
      <h3 class="col-12">Adicionar consultório</h3>
    </div>
    <div class="flex-space_between" v-else>
      <div class="dropdown" :class="officeDropdown ? 'active' : ''">
        <transition name="fade" mode="out-in">
          <h3 @click="officeDropdown = !officeDropdown" :key="selectedOffice">
            <a v-if="fn_IS_MOBILE() && !selectedOffice" class="whitespace-no-wrap">Adicionar consultório <i class="icon icon-caret"></i></a>
            <a class="dropdown-toggle" tabindex="0" v-else-if="offices[selectedOfficeList]">
              {{offices[selectedOfficeList].name}} <i v-if="officesTotal > 1" class="icon icon-caret"></i>
            </a>
          </h3>
        </transition>
        <!-- menu component -->
        <ul class="menu" :class="fn_IS_MOBILE() ? (officeDropdown ? '' : '!hidden') : ''" v-if="officesTotal > 0">
          <li v-for="office in offices" :key="'office' + office.id" class="menu-item" @click="()=>{$nextTick(()=>{officeDropdown = false;fn_LOG(officeDropdown)})}" >
            <a @click="selectedOfficeList = office.id; officeSelect(offices[selectedOfficeList].id)">{{office.name}}</a>
          </li>
        </ul>
      </div>
      <button v-if="selectedOffice" @click="addNewOffice()" type="button" class="btn-adicionar-consultorio btn btn-primary float-right"><i class="icon icon-plus"></i> Adicionar consultório</button>
    </div>
    <transition name="fade">
    <form class="columns" @submit.prevent="submit()" :key="selectedOfficeList">
      <aside class="column columns col-7">
        <small style="padding:0.25rem; font-size: 0.7rem;">
          Ao digitar seu CEP, aguarde que as suas informações
          de endereço sejam preenchidas automaticamente.
        </small>

        <dr-field
          v-bind:form.sync="formOffice"
          v-bind:validators.sync="$v.formOffice.name"
          v-bind:field.sync="formOffice.name"
          v-bind:apiErrors.sync="apiErrors['name']"
          :id="'name'"
          :ref="'name'"
          :key="'main_name'">
        </dr-field>
        <dr-field
          prefix="form1"
          class="text-left margin-auto transparent"
          v-bind:form.sync="formInterval"
          v-bind:field.sync="formInterval.intervals"
          v-bind:validators.sync="$v.formInterval.intervals"
          :id="'intervals'"
          :ref="'intervals'"
          >
        </dr-field>
        <dr-field
          v-bind:form.sync="formOffice"
          v-bind:validators.sync="$v.formOffice['address.cep']"
          v-bind:field.sync="formOffice['address.cep']"
          v-bind:apiErrors.sync="apiErrors['address.cep']"
          :id="'address.cep'"
          :ref="'address.cep'"
          :key="'main_address.cep'">
        </dr-field>
      </aside>
      <aside class="column col-5" v-if="!fn_IS_MOBILE() && (!selectedOffice && officesTotal > 0)">
        <strong>Meus consultórios ({{officesTotal}})</strong>
        <div class="s-rounded offices">
          <div class="dropdown" :class="officeDropdown ? 'active' : ''">
            <a v-if="officesTotal > 1" @click="officeDropdown = !officeDropdown" class="dropdown-toggle" tabindex="0">
              <h3>{{offices[selectedOfficeList].name}} <i class="icon icon-caret"></i></h3>
            </a>
            <a v-else>
              <h3>{{offices[selectedOfficeList].name}}</h3>
            </a>
            <!-- menu component -->
            <ul class="menu">
              <li v-for="office in offices" @click="officeDropdown = false" :key="'office' + office.id" class="menu-item">
                <a @click="selectedOfficeList = office.id">{{office.name}}</a>
              </li>
            </ul>
          </div>

          <ul class="list-unstyled">
            <!-- <li>
              <strong>
                Preço consulta
              </strong><br />
              R${{offices[selectedOfficeList].specialty_price}},00
            </li> -->
            <li>
              <strong>
                Endereço
              </strong>
              {{offices[selectedOfficeList].address.street}}, {{offices[selectedOfficeList].address.number}} {{offices[selectedOfficeList].address.complement ? '- ' + offices[selectedOfficeList].address.complement : ''}} - {{offices[selectedOfficeList].address.city.name || '-'}}/{{offices[selectedOfficeList].address.uf.name || '-'}}
            </li>
            <li class="text-right">
              <a @click="officeSelect(offices[selectedOfficeList].id)">Editar</a>
            </li>
          </ul>
        </div>
      </aside>
      <div class="column columns col-12">
        <dr-field
          v-for="(field, name) in getFormOffice"
          v-bind:form.sync="formOffice"
          v-bind:validators.sync="$v.formOffice[name]"
          v-bind:field.sync="field"
          v-bind:apiErrors.sync="apiErrors[name]"
          :id="name"
          :ref="name"
          :key="'main_'+name">
        </dr-field>

        <hr class="col-12" />
        <div class="payment column col-6 hide">
          <label ><strong>Valor da consulta</strong> </label>
          <span class="tooltip tooltip-top" :data-tooltip="`Esse é o preço que você médico receberá a\ncada consulta do tipo Dr. Conecta.\nO valor final exibido ao paciente, no App, será\nesse preço somado a nossa taxa de conveniência.`">
          <dr-icon class="v-icon" color="gray" name="info" key="tooltip_1"></dr-icon>
          </span>
          <ul class="list-unstyled">
            <li class="form-group " >
              <label class="form-radio form-inline">
                <input type="radio"
                  checked="checked"
                  :value="globalPrice" />
                <i class="form-icon"></i> R$ {{globalPrice}}
              </label>
            </li>
          </ul>
        </div>

        <!-- <section class="available-days card">
          <header class="available-days__header">
            <h3 class="available-days__title">
              Configure abaixo os dias e o tempo das consultas para os pacientes que virão do aplicativo Dr. Conecta.
            </h3>
          </header>

          <div class="available-days__body">
            <div class="payment col-5">
              <dr-field
                prefix="form1"
                class="text-left margin-auto transparent"
                v-bind:form.sync="formInterval"
                v-bind:field.sync="formInterval.intervals"
                v-bind:validators.sync="$v.formInterval.intervals"
                :id="'intervals'"
                :ref="'intervals'"
                >
              </dr-field>
            </div>

            <transition name="fade">
              <div class="agenda column col-12" v-if="formInterval.intervals.value">
                <label class="form-label">
                  Dias disponíveis para consulta Dr. Conecta
                  <span
                    class="tooltip tooltip-top"
                    :data-tooltip="`Você precisa disponibilizar ao\nmenos 3 horários e 2 dias\ndistintos aos pacientes Dr. Conecta.\nCada horário deve ser igual ou\nsuperior ao tempo de consulta\ninformado.`"
                  >
                    <dr-icon
                      class="v-icon"
                      color="#999"
                      fill="#999"
                      name="info"
                      key="tooltip_2"
                    />
                  </span>
                </label>

                <ul class="list-unstyled">
                  <li v-for="(value, $index) of formAgenda.weekdays" :key="$index">

                    <label class="weekday" :for="$index" :class="checkSelected($index)">{{ value }}</label>
                    <input :id="$index" type="checkbox" :value="$index" v-model="formAgenda.weekdaysSelected" />

                    <div v-if="formAgenda.weekdaysSelected.indexOf($index) > -1 && formAgenda.weekdaysSelectedObjs[value]" class="periods">
                      <main>
                        <fieldset class="form-group">
                          <label for="das">das </label>
                          <div class="timepicker">
                            <select
                              class="form-select"
                              @change="selectStart(value, formAgenda.weekdaysSelectedObjs[value].start.hours)"
                              v-model="formAgenda.weekdaysSelectedObjs[value].start.hours">
                              <option disabled>HH</option>
                              <option v-for="n in 24" :selected="n === 12" :key="n" :value="n">
                                {{ String(n).padStart(2, 0) }}
                              </option>
                            </select>
                            :
                            <select
                              class="form-select"
                              v-model="formAgenda.weekdaysSelectedObjs[value].start.minutes">
                              <option disabled>MM</option>
                              <option
                                v-for="i of Array.range(0, 59, 5)"
                                :value="String(i).padStart(2, 0)"
                                :key="'minuteend' + i">
                                {{ String(i).padStart(2, 0) }}
                              </option>
                            </select>
                          </div>
                        </fieldset>
                        <fieldset class="form-group">
                          <label for="as">às </label>
                          <div class="timepicker">
                            <select
                              class="form-select"
                              v-model="formAgenda.weekdaysSelectedObjs[value].end.hours">
                              <option disabled>HH</option>
                              <option
                                v-for="n in 23"
                                v-show="n >= formAgenda.weekdaysSelectedObjs[value].start.hours"
                                :value="n"
                                :key="n">
                                {{ String(n).padStart(2, 0) }}
                              </option>
                            </select>
                            :
                            <select
                              class="form-select"
                              v-model="formAgenda.weekdaysSelectedObjs[value].end.minutes">
                              <option disabled>MM</option>
                              <option
                                v-for="i of Array.range(0, 59, 5)"
                                :value="String(i).padStart(2, 0)"
                                :key="'minuteend' + i">
                                {{ String(i).padStart(2, 0) }}
                              </option>
                            </select>
                          </div>
                        </fieldset>
                        <button
                          @click="addPeriod(value, formAgenda.weekdaysSelectedObjs[value].start, formAgenda.weekdaysSelectedObjs[value].end)"
                          class="btn btn-sm btn-white"
                          type="button">
                          Adicionar
                        </button>
                      </main>
                      <footer class="chip-wrapper">
                        <transition-group name="fade">
                          <div
                            class="chip text-italic"
                            v-for="(time, $index) of formAgenda.weekdaysSelectedObjs[value].periods"
                            :key="'period' + $index">
                            <div>
                              <span>das {{ time.start }}</span>
                              <span>às {{ time.end }}</span>
                            </div>
                            <strong @click="removePeriod(value, $index)" class="close"></strong>
                          </div>
                        </transition-group>
                      </footer>
                    </div>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </section> -->
        <footer class="officeEnd">
          <dr-submit
            :disabled="$v.formOffice.$invalid || $v.formInterval.$invalid || !isDisabled"
            :sending="sending"
            text="Salvar" />
          <div v-if="officesTotal > 1 && validateStoredPeriods">
            <a v-if="selectedOffice" @click="deleteOffice()" :sending="deleting" class="btn text-error">
              <u>Remover consultório</u>
            </a>
          </div>
        </footer>
      </div>
    </form>
    </transition>
  </main>
</template>
<script>
import { formData, validations } from '@/data/formData/office.js'
import { required } from 'vuelidate/lib/validators'
import drSubmit from '@/components/form/submit'
import drField from '@/components/form/field'
import EventBus from '@/globals/eventBus'

Array.range = (from, to, step) => Array.from({length: ~~((to - from) / step) + 1}, (v, k) => from + k * step)

export default {
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      offices: {},
      officesTotal: 0,
      formOffice: formData,
      selectedOfficeList: 0,
      selectedOffice: 0,
      selectedOfficeTotalMinutes: 0,
      officeDropdown: false,
      ending: false,
      cepLoaded: false,
      loaded: false,
      loading: false,
      sending: false,
      deleting: false,
      localActive: true,
      agendaIndex: 0,
      globalPrice: 150, // REMOVER QUANDO API FOR RESOLVIDA
      apiErrors: this.fn_BUILD_API_ERRORS(this.formOffice),
      formInterval: {
        intervals: {
          size: 12,
          type: 'select',
          name: 'specialties',
          label: 'Tempo médio de consulta',
          required: true,
          placeholder: 'Informe o tempo médio de sua consulta',
          sending: false,
          value: '',
          options: [
            {
              id: 1,
              name: '15 minutos',
              interval: '00:15'
            },
            {
              id: 2,
              name: '30 minutos',
              interval: '00:30'
            },
            {
              id: 3,
              name: '45 minutos',
              interval: '00:45'
            },
            {
              id: 4,
              name: '1 hora',
              interval: '01:00'
            },
            {
              id: 5,
              name: '1 hora e 30 minutos',
              interval: '01:30'
            },
            {
              id: 6,
              name: '2 horas',
              interval: '02:00'
            }
          ]
        }
      },
      formAgenda: {
        weekdays: {
          0: 'domingo',
          1: 'segunda',
          2: 'terça',
          3: 'quarta',
          4: 'quinta',
          5: 'sexta',
          6: 'sábado'
        },
        weekdaysSelected: [],
        weekdaysSelectedObjs: {}
      },
      agendaPeriods: []
    }
  },
  computed: {
    isDisabled () {
      this.getPeriodsTotalMinutes()
      if (this.validateStoredPeriods()) {
        return (this.agendaPeriods.length === 0) ? true : this.arePeriodsValid
      }

      // return this.agendaPeriods.length > 0 && this.isAgendaValid
      return true
    },
    arePeriodsValid () {
      this.getPeriodsTotalMinutes()
      if (this.agendaPeriods.length > 0) {
        return this.agendaPeriods.every(day =>
          day.every(period => period.minutes >= this.selectedOfficeInterval)
        )
      }
      return true
    },
    isAgendaValid () {
      this.getPeriodsTotalMinutes()
      //   // Regra 1: ao menos dois dias disponíveis na agenda
      //   const atLeastTwoDays = this.agendaPeriods.length >= 2

      //   // Regra 2: total de minutos >= 3 * o tempo médio da consulta
      //   const totalMinutes = this.selectedOfficeTotalMinutes >= 3 * this.selectedOfficeInterval

      //   // Regra 3: cada horário disponível deve ser >= ao tempo médio da consulta
      //   const arePeriodsValid = this.arePeriodsValid

      //   return atLeastTwoDays && totalMinutes && arePeriodsValid
      return true
    },
    getFormOffice () {
      let obj = {}
      let exclude = ['name', 'address.cep']
      for (let field in this.formOffice) {
        if (exclude.indexOf(field) === -1) {
          obj[field] = this.formOffice[field]
        }
      }
      return obj
    },
    watchCep () {
      if (this.formOffice) {
        return this.formOffice['address.cep'].value
      }
      return ''
    },
    selectedOfficeInterval () {
      let selectedInterval = 0
      this.formInterval.intervals.options.forEach((interval) => {
        selectedInterval = (interval.id === this.formInterval.intervals.value) ? interval.interval : selectedInterval
      })
      const intervalDate = this.$moment.duration(selectedInterval, 'HH:mm')
      return intervalDate.asMinutes()
    }

  },
  watch: {
    watchCep: {
      deep: false,
      immediate: false,
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          const regex = /([\d]){5}-([\d]){3}/g // RegEx CEP
          if (regex.test(newValue)) {
            this.searchAddress(newValue)
          }
        }
      }
    },

    selectedOfficeInterval (next, prev) {
      Object.keys(this.formAgenda.weekdaysSelectedObjs).forEach((day) => {
        if ('mergedIntervals' in this.formAgenda.weekdaysSelectedObjs[day]) {
          if (this.formAgenda.weekdaysSelectedObjs[day].mergedIntervals.some((interval) => next > interval.minutes)) {
            const errorMessage = {
              title: 'Atenção',
              body: 'Alguns dos horários disponibilizados são menores que o tempo de consulta informado. Por favor, corrija antes de prosseguir.',
              active: true,
              size: 'sm',
              callback: null
            }
            this.$store.dispatch('setModalAlert', errorMessage)
          }
        }
      })
    },
    formAgenda: {
      deep: true,
      handler (next, prev) {
        const daysObj = Object.keys(this.formAgenda.weekdaysSelectedObjs)
        const daysToggle = []

        next.weekdaysSelected.forEach((index) => {
          Object.keys(this.formAgenda.weekdays).forEach((day) => {
            if (day === index) {
              daysToggle.push(this.formAgenda.weekdays[day])
            }
          })
        })

        this.addToWeekdaysObj(daysToggle, daysObj)
        this.removeFromWeekdaysObj(daysToggle, daysObj)
      }
    }
  },

  validations: {
    formOffice: validations,
    formInterval: {
      intervals: {
        value: { required }
      }
    }
  },
  mounted () {
    this.fetchOffices()
      .then(() => {
        this.officeSelect()
      })
      .catch(err => console.log(err))
  },
  methods: {
    getAgendaPeriods () {
      const weekdays = []
      Object.keys(this.formAgenda.weekdaysSelectedObjs).forEach((day) => {
        const intervals = []
        if ('mergedIntervals' in this.formAgenda.weekdaysSelectedObjs[day]) {
          this.formAgenda.weekdaysSelectedObjs[day].mergedIntervals.forEach((interval) => {
            if (interval) {
              intervals.push(interval)
            }
          })
          weekdays.push(intervals)
        }
      })
      this.agendaPeriods = weekdays
    },
    validateStoredPeriods () {
      const offices = []
      let isAnotherOfficeValid = false

      Object.keys(this.offices).forEach((office) => {
        if (String(office) !== String(this.selectedOffice)) {
          const appointmentIntervalDate = new Date(this.offices[office]['appointment_interval'])
          const appointmentIntervalMinutes = (appointmentIntervalDate.getHours() * 60) + appointmentIntervalDate.getMinutes()
          const weekdays = []

          this.offices[office]['exclusive_days_agendas'].forEach((day) => {
            const periods = []

            day['exclusive_period_agendas'].forEach((period) => {
              const startDate = new Date(period['period_start'])
              const endDate = new Date(period['period_stop'])
              const diff = this.convertIntervalToMinutes(
                `${String(startDate.getHours()).padStart(2, 0)}:${String(startDate.getMinutes()).padStart(2, 0)}`,
                `${String(endDate.getHours()).padStart(2, 0)}:${String(endDate.getMinutes()).padStart(2, 0)}`
              )

              periods.push(diff)
            })

            weekdays.push(periods)
          })

          offices.push({ 'appointmentInterval': appointmentIntervalMinutes, weekdays })
        }
      })

      isAnotherOfficeValid = offices.some((office) => {
        return (
          office.weekdays.length >= 2 &&
          office.weekdays.every((day) => day.every(time => time >= office.appointmentInterval)) &&
          office.weekdays.flat().reduce((t, v) => t + v, 0) >= 3 * office.appointmentInterval
        )
      })

      return isAnotherOfficeValid
    },
    fetchOffices () {
      return new Promise((resolve, reject) => {
        this.fn_SHOW_PROGRESS()
        this.offices = {}

        const url = this.fn_GET_PARENT_ROUTE(this.$route) === 'doctor'
          ? '/doctor'
          : `${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor`

        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            let i = 0
            for (let office of res.data.doctor_offices) {
              if (/facetoface/gi.test(office.type)) {
                if (i === 0) {
                  this.selectedOffice = office.id
                  this.selectedOfficeList = office.id
                }
                this.offices[office.id] = office
                i = i + 1
              }
            }
            this.officesTotal = i
            if (i > 0) {
              this.getPrices()
            }
            resolve()
          })
          .catch(err => reject(err))
          .finally(() => {
            this.fn_HIDE_PROGRESS()
          })
      })
    },
    addNewOffice () {
      this.selectedOffice = false
      this.resetForm()
      this.getPrices()
      this.$forceUpdate()
      this.$v.$reset()
    },
    officeSelect (id = null) {
      this.cepLoaded = true
      this.selectedOffice = id || Object.keys(this.offices)[0]
      this.selectedOfficeList = this.selectedOffice
      this.resetForm()
      if (this.officesTotal > 0) {
        this.getPrices()
        this.populateForm(this.offices[parseInt(this.selectedOffice)])
        return
      }
      this.loaded = true
    },
    getWeekdayIndex (day) {
      for (let index in this.formAgenda.weekdays) {
        if (this.formAgenda.weekdays[index] === day) {
          return index
        }
      }
    },
    resetForm () {
      this.agendaPeriods = []
      this.formAgenda.weekdaysSelected = []
      this.formAgenda.weekdaysSelectedObjs = {}
      for (let field in this.formOffice) {
        this.formOffice[field].value = ''
      }
      // this.formPayment.priceSelected = false
      // this.formPayment.priceReal = null
      this.formInterval.intervals.value = null
      this.selectedOfficeTotalMinutes = 0
      this.$forceUpdate()
    },
    populateForm (data) {
      this.fn_FLATTEN_OBJECT(data).then(
        (res) => {
          // this.formPayment.priceReal = res.specialtyPrice
          // this.formPayment.priceSelected = null
          this.formAgenda.weekdaysSelected = []
          this.formAgenda.weekdaysSelectedObjs = {}
          for (let field in res) {
            if (field === 'address.cep') {
              this.formOffice[field].value = res[field].replace('-', '')
              continue
            }
            if (field === 'address.uf.id') {
              this.formOffice['address.uf'].value = res['address.uf.id']
              continue
            }
            if (this.formOffice[field]) {
              this.formOffice[field].value = res[field]
            }
          }
          // this.formPayment.priceSelected = res.specialtyPrice

          let interval = new Date(res.appointmentInterval)
          interval = `${String(interval.getHours()).padStart(2, 0)}:${String(interval.getMinutes()).padStart(2, 0)}`

          for (let i of this.formInterval.intervals.options) {
            if (i.interval === interval) {
              this.formInterval.intervals.value = i.id
            }
          }

          this.agendaIndex = res.exclusiveDaysAgendas.length
          for (let agenda of res.exclusiveDaysAgendas) {
            let dayIndex = null
            Object.keys(this.formAgenda.weekdays).forEach((key) => {
              dayIndex = (this.formAgenda.weekdays[key] === this.fn_FROM_WEEKDAY(agenda.day_of_week)) ? key : dayIndex
            })
            this.toggleSelected(dayIndex)
            this.formAgenda.weekdaysSelected.push(this.getWeekdayIndex(this.fn_FROM_WEEKDAY(agenda.day_of_week)))

            for (let period of agenda.exclusive_period_agendas) {
              const dateStart = new Date(period.period_start)
              const dateEnd = new Date(period.period_stop)

              const start = {
                hours: String(dateStart.getHours()).padStart(2, 0),
                minutes: String(dateStart.getMinutes()).padStart(2, 0)
              }
              const finish = {
                hours: String(dateEnd.getHours()).padStart(2, 0),
                minutes: String(dateEnd.getMinutes()).padStart(2, 0)
              }

              this.addPeriod(this.fn_FROM_WEEKDAY(agenda.day_of_week), start, finish)
            }
          }
          this.loaded = true
          this.$forceUpdate()
          // this.cepLoaded = false
        }
      )
    },
    selectStart (day, value) {
      const start = this.formAgenda.weekdaysSelectedObjs[day].start.hours
      const end = this.formAgenda.weekdaysSelectedObjs[day].end.hours

      if (end <= start) {
        this.formAgenda.weekdaysSelectedObjs[day].end.hours = value + 1
        this.$forceUpdate()
      }
    },
    toggleSelected (day, index) {
      if (!day) {
        return
      }
      const dayName = this.formAgenda.weekdays[day]
      if (!this.formAgenda.weekdaysSelectedObjs[dayName]) {
        let selectedDay = {
          day: this.fn_TO_WEEKDAY(day),
          start: { hours: 12, minutes: '00' },
          end: { hours: 13, minutes: '00' },
          periods: []
        }
        this.formAgenda.weekdaysSelectedObjs[dayName] = selectedDay
      } else {
        this.$delete(this.formAgenda.weekdaysSelectedObjs, dayName)
      }
      this.$forceUpdate()
    },
    checkSelected (day) {
      if (this.formAgenda.weekdaysSelected.indexOf(day) > -1) {
        return 'selected'
      }
    },
    removePeriod (day, period) {
      for (let selected in this.formAgenda.weekdaysSelectedObjs) {
        if (selected === day) {
          this.$delete(this.formAgenda.weekdaysSelectedObjs[selected].periods, period)
          this.formAgenda.weekdaysSelectedObjs[selected].mergedIntervals = this.mergeIntervals(this.formAgenda.weekdaysSelectedObjs[selected].periods)
        }
      }
      this.$forceUpdate()
      this.getPeriodsTotalMinutes()
      this.getAgendaPeriods()
    },
    convertIntervalToMinutes (start = null, end = null) {
      if (start && end) {
        const intervalStart = this.$moment.utc(start, 'HH:mm')
        const intervalEnd = this.$moment.utc(end, 'HH:mm')
        const intervalMinutes = intervalEnd.diff(intervalStart, 'minutes')

        return intervalMinutes
      }
      return 0
    },
    addPeriod (index, start, end) {
      let period = Object.freeze({
        start: `${start.hours}:${start.minutes}`,
        end: `${end.hours}:${end.minutes}`
      })

      if (this.convertIntervalToMinutes(period.start, period.end) < this.selectedOfficeInterval) {
        const errorMessage = {
          title: 'Erro',
          body: 'O horário escolhido é menor que o tempo médio de consulta informado.',
          active: true,
          size: 'sm',
          callback: null
        }
        this.$store.dispatch('setModalAlert', errorMessage)
        return
      }

      if (this.formAgenda.weekdaysSelectedObjs[index].periods.length >= 1) {
        const add = !this.formAgenda.weekdaysSelectedObjs[index].periods.some(time =>
          (time.start === period.start) && (time.end === period.end)
        ) && (period.start !== period.end)
        if (add) {
          this.formAgenda.weekdaysSelectedObjs[index].periods.push(period)
        }
      } else {
        this.formAgenda.weekdaysSelectedObjs[index].periods.push(period)
      }

      this.formAgenda.weekdaysSelectedObjs[index].periods.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))
      this.formAgenda.weekdaysSelectedObjs[index].mergedIntervals = this.mergeIntervals(this.formAgenda.weekdaysSelectedObjs[index].periods)
      this.$forceUpdate()

      this.getPeriodsTotalMinutes()
      this.getAgendaPeriods()
    },
    getPrices () {
      this.globalPrice = '150,00'
      // this.$http.get(`/doctor/doctor_office/${this.selectedOffice}/specialty_price/default`, this.$store.getters.getAuthHeader).then(
      //   (res) => {
      //     this.globalPrice = res.data.global_price.toFixed(2).replace('.', ',')
      //   }
      // ).catch(err => {
      //   console.log(err)
      // }).finally(() => {
      //   this.fn_HIDE_PROGRESS()
      // })
    },
    deleteOffice () {
      // const this = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja remover o consultório?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v, scope) => {
          scope.sending = true
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()
            this.$http
              .delete(`doctor/doctor_office/${this.selectedOffice}`, this.$store.getters.getAuthHeader)
              .then((res) => {
                this.$store.dispatch('setModalConfirm')
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'Consultório removido com sucesso',
                  size: 'md',
                  active: true
                })
                this.fetchOffices().then(() => {
                  this.officeSelect()
                })
                this.fn_HIDE_PROGRESS()
              })
              .then(this.fn_GET_OFFICES)
          }
        },
        size: 'md',
        active: true
      })
    },

    submit () {
      let data = this.fn_COPY_OBJECT(this.formOffice)
      data['address.cep'].value = this.fn_NUMBERS_ONLY(data['address.cep'].value)

      this.sending = true

      data = this.fn_EXPAND_OBJECT(data)

      data.exclusiveDaysAgendas = {}
      let i = this.agendaIndex
      for (let exclusiveDaysAgendas in this.formAgenda.weekdaysSelectedObjs) {
        let obj = {
          dayOfWeek: this.fn_TO_WEEKDAY(exclusiveDaysAgendas),
          exclusivePeriodAgendas: []
        }

        if ('mergedIntervals' in this.formAgenda.weekdaysSelectedObjs[exclusiveDaysAgendas]) {
          for (let exclusivePeriod of this.formAgenda.weekdaysSelectedObjs[exclusiveDaysAgendas].mergedIntervals) {
            obj.exclusivePeriodAgendas.push({
              periodStart: exclusivePeriod.start,
              periodStop: exclusivePeriod.end
            })
          }
        }
        data.exclusiveDaysAgendas[i] = obj
        i++
      }

      // Remove dias selecionados que não tenham horários selecionados
      for (let day in data.exclusiveDaysAgendas) {
        if (data.exclusiveDaysAgendas[day].exclusivePeriodAgendas.length === 0) {
          delete data.exclusiveDaysAgendas[day]
        }
      }

      data.appointmentInterval = this.formInterval.intervals.options[this.formInterval.intervals.value - 1].interval
      // data.doctorOfficeMedicalServices = [
      //   {
      //     price: this.formPayment.priceReal + '.00',
      //     medicalService: 8
      //   }
      // ]
      // data.specialtyPrice = this.formPayment.priceReal + '.00'

      this.fn_SHOW_PROGRESS()
      delete data.exclusiveDaysAgendas

      this.$http
        .get(`https://maps.google.com/maps/api/geocode/json?key=${this.$store.getters.$_getMapsApi}&address=${data.address.street + ', ' + data.address.number}`)
        .then((res) => {
          if (res.data.results.length === 0) {
            console.log(`gmaps couldn't find address`, res)
            // this.sending = false
            // this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
            // this.fn_HIDE_PROGRESS()
            // return
          } else {
            data.address.latitude = res.data.results[0].geometry.location.lat
            data.address.longitude = res.data.results[0].geometry.location.lng
          }

          let apiCall = '/doctor/doctor_office'
          let method = 'post'
          let message = 'Consultório criado com sucesso'
          if (this.selectedOffice) {
            apiCall = apiCall + '/' + this.selectedOffice
            method = 'put'
            message = 'Consultório atualizado com sucesso'
          }

          this.$http(
            {
              method: method,
              url: apiCall,
              data: { 'doctor_office': data },
              headers: this.$store.getters.getAuthHeader.headers
            }
          )
            .then((res) => {
              this.sending = false
              this.$store.dispatch('setModalAlert', {
                title: 'Sucesso',
                body: message,
                size: 'md',
                active: true
              })

              if (this.officesTotal === 0) {
                this.$emit('reloadTour', 1)
              }

              let officeId = this.selectedOffice
              this.fetchOffices()
                .then(() => {
                  officeId = (method === 'post') ? Object.keys(this.offices).reverse()[0] : officeId
                  this.officeSelect(officeId)
                })
                .catch(err => console.log(err))
            })
            .then(() => this.fn_GET_DOCTOR())
            .then((res) => EventBus.$emit('updated-user-data', res))
            .catch((err) => {
              console.log(err)
              this.fn_HIDE_PROGRESS()
              if (err.status === 400 || err.code === 400) {
                let errorInterval = null
                errorInterval = {
                  title: 'Erro',
                  body: ('errors' in err.errors) ? err.errors.errors[0] : 'Ocorreu um erro',
                  active: true,
                  size: 'sm',
                  callback: null
                }
                this.fn_FLATTEN_OBJECT(err.errors.children).then(
                  (res) => {
                    for (let field in res) {
                      this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                    }
                    let errorMessage = (!!errorInterval === !!null) ? this.ERROR_MESSAGES.modal.form : errorInterval
                    this.$store.dispatch('setModalAlert', errorMessage)
                  }
                )
                this.sending = false
              } else {
                console.log(err)
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
              }
            })
            .finally(() => {
              this.fn_HIDE_PROGRESS()
            })
        })
        .catch(
          (err) => {
            this.fn_HIDE_PROGRESS()
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: 'Erro de comunicação externa, por favor tente mais tarde',
              size: 'sm',
              active: true
            })
            this.sending = false
            console.log(err)
          })
    },

    searchAddress (cep) {
      this.$http
        .get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`)
        .then((res) => {
          if (res.data) {
            const { data } = res
            const getUF = (uf = null, id = null) => {
              return this.formOffice['address.uf'].options
                .find(item => item.name === uf || item.id === id)
            }
            const setDisable = (object, property, value) => {
              property.forEach(p => (object[p].disabled = value))
            }

            if ('erro' in data) {
              this.$store.dispatch('setModalConfirm', {
                title: 'CEP não encontrado',
                body: 'Deseja pesquisar um outro CEP ou editar o endereço manualmente?',
                confirmText: 'Editar',
                cancelText: 'Pesquisar',
                beforeClose: (v) => {
                  if (v) {
                    setDisable(
                      this.formOffice,
                      [
                        'address.street',
                        'address.district',
                        'address.city.name',
                        'address.uf'
                      ],
                      false
                    )
                  }
                  this.$store.dispatch('setModalConfirm')
                },
                size: 'md',
                active: true
              })
            } else {
              setDisable(
                this.formOffice,
                [
                  'address.district',
                  'address.city.name',
                  'address.uf',
                  'address.street'
                ],
                true
              )
              // se encontrou o CEP, mas sem rua e bairro, habilita estes campos para edição
              if ((data.logradouro.length + data.bairro.length) === 0) {
                setDisable(
                  this.formOffice,
                  [
                    'address.district',
                    'address.street'
                  ],
                  false
                )
              }

              this.formOffice['address.street'].value = data.logradouro
              this.formOffice['address.district'].value = data.bairro
              this.formOffice['address.city.name'].value = data.localidade
              this.formOffice['address.uf'].value = getUF(data.uf).id

              const key = this.$store.getters.$_getMapsApi
              const address = `${this.formOffice['address.street'].value},
                ${this.formOffice['address.number'].value},
                ${this.formOffice['address.district'].value},
                ${this.formOffice['address.city.name'].value} -
                ${getUF(null, this.formOffice['address.uf'].value).name}`

              this.$http
                .get(`https://maps.google.com/maps/api/geocode/json?key=${key}&address=${address}`)
                .then((res) => {
                  if (res.status === 200) {
                    const { data } = res
                    if (data.results.length > 0) {
                      const { geometry } = data.results[0]
                      this.formOffice['address.latitude'].value = geometry.location.lat
                      this.formOffice['address.longitude'].value = geometry.location.lng
                    }
                  }
                })
                .catch((err) => {
                  console.log('err', err)
                })
            }
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },

    mergeIntervals (intervals = []) {
      // Deep copy + prevent reference change
      intervals = JSON.parse(JSON.stringify(intervals))
      let newIntervals = []
      newIntervals = [intervals[0]]

      if (intervals.length > 1) {
        // Copy frozen object
        intervals = JSON.parse(JSON.stringify(intervals))
        intervals.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))

        for (let i = 1; i < intervals.length; i++) {
          const firstIntervalEnd = this.$moment.utc(newIntervals[0].end, 'HH:mm')
          const currentIntervalStart = this.$moment.utc(intervals[i].start, 'HH:mm')
          const currentIntervalEnd = this.$moment.utc(intervals[i].end, 'HH:mm')

          if (currentIntervalStart.isSameOrBefore(firstIntervalEnd) && currentIntervalEnd.isSameOrAfter(firstIntervalEnd)) {
            newIntervals[0].end = intervals[i].end
          }

          if (currentIntervalStart.isAfter(firstIntervalEnd)) {
            newIntervals.unshift(intervals[i])
          }
        }
      }

      newIntervals.sort((a, b) => parseInt(a.start.replace(':', '')) - parseInt(b.start.replace(':', '')))
      newIntervals.forEach((interval) => {
        if (interval) {
          interval.minutes = this.convertIntervalToMinutes(interval.start, interval.end)
        }
      })

      this.getPeriodsTotalMinutes()

      return newIntervals
    },

    getPeriodsTotalMinutes () {
      // Calcula o total de minutos escolhidos na semana
      const arrayWeekdaysSelectedObjs = Object.entries(this.formAgenda.weekdaysSelectedObjs)
      const daysPeriods = []
      let totalMinutes = 0

      arrayWeekdaysSelectedObjs.forEach(day => daysPeriods.push(day[1]))

      daysPeriods.forEach((day) => {
        if ('mergedIntervals' in day) {
          day.mergedIntervals.forEach((merged) => {
            if (merged) {
              totalMinutes += merged.minutes
            }
          })
        }
      })

      this.selectedOfficeTotalMinutes = totalMinutes
    },

    addToWeekdaysObj (daysToggle = [], daysObj = []) {
      const filtered = daysToggle.filter(day => !daysObj.includes(day))

      if (filtered.length > 0) {
        filtered.forEach((day) => {
          const selectedDay = {
            day: this.fn_TO_WEEKDAY(day),
            start: { hours: 12, minutes: '00' },
            end: { hours: 13, minutes: '00' },
            periods: []
          }
          this.formAgenda.weekdaysSelectedObjs[day] = selectedDay
        })
      }
    },

    removeFromWeekdaysObj (daysToggle = [], daysObj = []) {
      const filtered = daysObj.filter(day => !daysToggle.includes(day))

      if (filtered.length > 0) {
        filtered.forEach((day) => {
          this.$delete(this.formAgenda.weekdaysSelectedObjs, day)
        })
      }
    }
  }
}
</script>
